angular.module('impactx.rfx').service('RFXCreateService', RFXCreateService);

RFXCreateService.$inject = ['dataGen', '$mdDialog', '$redirect'];

function RFXCreateService(dataGen, $mdDialog, $redirect) {

    var redirect = function (rfqcId, supplierId, type, id) {
        let redirectTo = '/rfxbuyer/0/' + rfqcId
        if(type === "tender")
        {
            redirectTo = redirectTo + '/0/' + id;
        }
        else if(type === "lot")
        {
            redirectTo = redirectTo + '/0/0/' + id;
        }
        else if(supplierId > 0)
        {
            redirectTo = redirectTo+'/'+supplierId
        }
        $redirect.redirectTo(null, redirectTo)
    };

    this.createRFX = function (type, id, supplierId) {
        var paramObj = {
            type: type,
            id: id
        };
        dataGen.postAsForm({}, paramObj, '/rfx/rfqc/select').then(function (data) {
            if (data) {
                if (impactX.isDefined(data, 'data.rfqc.selected.id')) {
                    redirect(data.data.rfqc.selected.id, supplierId, type, id); // if preselected, then redirect directly
                }
                else if (data.data) {
                    $mdDialog.show({
                        controller: 'RFQCSelectionCtrl',
                        controllerAs: 'rfqcSelectionCtrl',
                        templateUrl: 'modules/rfx/templates/rfqcselection.tmpl.html',
                        parent: angular.element(document.body),
                        targetEvent: null,
                        clickOutsideToClose: false,
                        bindToController: true,
                        locals: {
                            data: data,
                            type: type,
                            id: id
                        }
                    }).then(function (rfqcId) {
                        redirect(rfqcId, supplierId, type, id);
                    })
                }
            }
        });
    }
}